import React, { Component, Fragment } from 'react';
import { get, post, postWithHeaders } from '../../../server/actions';
import moment from 'moment';
import logo from './../../../assets/img/logo1.png';
import NotificationSystem from 'react-notification-system';
import { _addNotification, _addNotificationError } from '../../../server/util';
import { ConfirmDialog } from './../../Misc/confirmDialog';
import DatePicker from "react-datepicker";
import PropTypes from 'prop-types';
import { date_format } from '../../../server/constants';

const styles = {
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '90vh',
    }
}
function DatePickerInputControl({ value, onChange }) {
    return (
        <input className='form-control rounded'
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onClick={(e) => e.target.focus()}
        />
    );

}
class SchoolYearForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isNewSchoolYearRequested: false,
            schoolYearOption: this.props.currentSchoolYear ? null : 1,
            loading: false,
            step: 0,
            currentSchoolYearState: this.props.currentSchoolYear ? this.props.currentSchoolYear.rec : null,
            futureSchoolYearState: this.props.futureSchoolYear ? this.props.futureSchoolYear.rec : null,
            previousSchoolYear: this.props.currentSchoolYear ? Number(this.props.currentSchoolYear.schoolYear) : null
        }
    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
        this.isRequestSubmitted();
    }
    componentWillReceiveProps = (nextProps) => {
        this.setState({
            schoolYearOption: nextProps.currentSchoolYear ? null : 1,
            currentSchoolYearState: nextProps.currentSchoolYear ? nextProps.currentSchoolYear.rec : null,
            futureSchoolYearState: nextProps.futureSchoolYear ? nextProps.futureSchoolYear.rec : null,
            previousSchoolYear: nextProps.currentSchoolYear ? Number(nextProps.currentSchoolYear.schoolYear) : null
        });
    }
    isRequestSubmitted = () => {
        get('/schoolYearRequests/verify?mealSchoolId=' + sessionStorage.getItem("SchoolId") + '&schoolYear=' + moment().format('YYYY') + '&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            this.setState({ isNewSchoolYearRequested: data.resp });
        }).catch(
            (error) => {
                console.log('Get School data response', error)
            }
        );
    }
    onClickExit = () => {
        let request = new Promise((resolve) => (get('/logout?access_token=').then(response => {
            if (!response.ok || response.ok) {
                resolve(sessionStorage.clear());
            }
        })));

        Promise.resolve(request).then(() => {
            window.location.replace('/login');
        });
    }
    renderSchoolYearRequestedMessage = () => {
        return (<Fragment>
            <div className="panel panel-primary border-primary" style={{ width: '30%' }}>
                <div className="panel-body text-center">
                    <img src={logo} width={'100px'} />
                    <p style={{ fontSize: '16px', paddingTop: '10px' }}>A request to create the new school year has already been submitted and is currently being processed. Once the school year is created, you will be notified via email. After that, you will be able to use both the new and previous school years.</p>
                    <div className='text-center'>
                        <button className='btn btn-sm btn-primary' onClick={() => this.onClickExit()}>Ok</button>
                    </div>
                </div>
            </div>
        </Fragment>)
    }
    onRequestNewSchoolYear = () => {
        ConfirmDialog(
            '_dialog1',
            'Confirmation Alert',
            `You're about to submit a new school year creation request. Are you sure you want to proceed?`,
            'Yes',
            'Cancel',
            (res) => {
                if (res) {
                    post('/schoolYearRequests?mealSchoolId=' + sessionStorage.getItem("SchoolId") + '&schoolYear=' + moment().format('YYYY') + '&access_token=').then((response) => {
                        if (!response.ok) {
                            throw Error(response.statusText);
                        }
                        return response.json();
                    }).then(data => {
                        if (data.statusCode == 200) {
                            _addNotification(data.statusMessage, this);
                            setInterval(() => {
                                window.location.replace('/schoolAdmin');
                            }, 1000);
                        }
                    }).catch(
                        (error) => {
                            console.log('Get School data response', error)
                        }
                    );
                }
            });
    }
    onLoginWithPreviousSchoolYear = () => {
        const { previousSchoolYear } = this.state;
        const selectedYear = previousSchoolYear !== null && previousSchoolYear !== undefined ? String(previousSchoolYear) : '';
        const selectedYearName = this.props.currentSchoolYear && this.props.currentSchoolYear.name ? this.props.currentSchoolYear.name : selectedYear;

        if (!selectedYear) {
            _addNotificationError('No previous school year is available to switch to.', this);
            return;
        }
        ConfirmDialog(
            '_dialog1',
            'Confirmation Alert',
            `You're about to switch to the previous school year. Are you sure you want to proceed?`,
            'Yes',
            'Cancel',
            (res) => {
                if (res) {
                    sessionStorage.setItem('schoolYear', selectedYearName);
                    sessionStorage.setItem('schoolYearValue', selectedYear);

                    const loggedInUserInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo') || '{}');
                    if (loggedInUserInfo && typeof loggedInUserInfo === 'object') {
                        loggedInUserInfo.schoolYear = selectedYear;
                        // Financial/claim reports read the active year off schools[].activeSchoolYear
                        // instead of sessionStorage, so keep both in sync or they keep pulling the
                        // current year after the user switches back.
                        (loggedInUserInfo.schools || []).forEach((school) => {
                            school.activeSchoolYear = previousSchoolYear;
                        });
                        sessionStorage.setItem('loggedInUserInfo', JSON.stringify(loggedInUserInfo));
                    }
                    _addNotification('Active school year redirected successfully.', this);
                    setTimeout(() => {
                        window.location.replace('/schoolAdmin');
                    }, 1000);
                }
            }
        );
    }

    saveSchoolYear = (e, isFutureSchoolYear) => {
        const { currentSchoolYearState, futureSchoolYearState } = this.state;
        e.preventDefault();
        if (isFutureSchoolYear) {
            ConfirmDialog(
                '_dialog1',
                'Confirmation Alert',
                `Do you want to update the Start Date for the New School Year?`,
                'Yes',
                'No',
                (res) => {
                    if (res) {
                        this.setState({ loading: true });
                        let headers = {
                            'Content-Type': 'application/json'
                        };
                        const id = futureSchoolYearState._links.self.href.split('/').pop();
                        postWithHeaders('/schoolYearSetup/' + id + '?mealSchoolId=' + sessionStorage.getItem('SchoolId') + '&access_token=',
                            JSON.stringify({
                                ...futureSchoolYearState,
                                sessionStartDateTime: moment(futureSchoolYearState.sessionStartDateTime).utc().format("YYYY-MM-DDTHH:mm:ss")
                            }),
                            headers).then((response) => {
                                if (!response.ok) {
                                    return response.json().then(errorData => {
                                        throw new Error(errorData.message || errorData.statusMessage || response.statusText);
                                    }).catch(() => {
                                        throw new Error(response.statusText);
                                    });
                                }
                                return response.text();
                            }).then(data => {
                                _addNotification("School Year data saved successfully.", this);
                                this.setState({ loading: false });
                                setInterval(() => {
                                    window.location.replace('/schoolAdmin');
                                }, 1000);
                            }).catch(
                                (error) => {
                                    console.log('School Year data not saved', error);
                                    _addNotificationError(error.message || 'School Year data not saved', this);
                                    this.setState({ loading: false });
                                }
                            );
                    }
                }
            );
        } else {
            this.setState({ loading: true });
            let headers = {
                'Content-Type': 'application/json'
            };
            const id = currentSchoolYearState._links.self.href.split('/').pop();
            postWithHeaders('/schoolYearSetup/' + id + '?mealSchoolId=' + sessionStorage.getItem('SchoolId') + '&access_token=',
                JSON.stringify({
                    ...currentSchoolYearState,
                    sessionEndDateTime: moment(currentSchoolYearState.sessionEndDateTime).utc().format("YYYY-MM-DDTHH:mm:ss")
                }),
                headers).then((response) => {
                    if (!response.ok) {
                        return response.json().then(errorData => {
                            throw new Error(errorData.message || errorData.statusMessage || response.statusText);
                        }).catch(() => {
                            throw new Error(response.statusText);
                        });
                    }
                    return response.text();
                }).then(data => {
                    _addNotification("School Year data saved successfully.", this);
                    this.setState({ loading: false });
                    setInterval(() => {
                        window.location.replace('/schoolAdmin');
                    }, 1000);
                }).catch(
                    (error) => {
                        console.log('School Year data not saved', error);
                        _addNotificationError(error.message || 'School Year data not saved', this);
                        this.setState({ loading: false });
                    }
                );
        }
    }


    renderSchoolYearSelectionOptions = () => {
        const { currentSchoolYear, futureSchoolYear } = this.props;
        const { schoolYearOption, step, currentSchoolYearState, loading, futureSchoolYearState } = this.state;
        return (<Fragment>
            <div className="panel panel-primary border-primary" style={{ width: '40%' }}>
                <div className="panel-body text-center">
                    <img src={logo} width={'125px'} />
                    {
                        step == 0 ? <Fragment>
                            <div className='row'>
                                <div className='col-sm-12 text-center'>
                                    <div className='text-left' style={{ paddingTop: '10px' }}>
                                        {
                                            futureSchoolYear ? <Fragment>
                                                <div className='row form-group'>
                                                    <div className='col-md-12 text-center'>
                                                        <label>
                                                            {`No active school year at the moment. The new school year begins on ${moment(futureSchoolYear.rec.sessionStartDateTime, 'YYYY-MM-DDThh:mm:ss').format(date_format())}.`}
                                                        </label>
                                                    </div>
                                                    <div className='col-md-12'>
                                                        <div className='row form-group'>
                                                            <div className='col-md-6'>
                                                                <label>New School Year Start Date :</label>
                                                            </div>
                                                            <div className='col-md-6 text-left'>
                                                                <DatePicker
                                                                    selected={moment(futureSchoolYearState.sessionStartDateTime, 'YYYY-MM-DDThh:mm:ss').toDate()}
                                                                    dateFormat={date_format().replace('YYYY', 'yyyy').replace('DD', 'dd')}
                                                                    minDate={new Date()}
                                                                    onChange={(date) => {
                                                                        const _futureSchoolYearState = this.state.futureSchoolYearState;
                                                                        _futureSchoolYearState.sessionStartDateTime = moment(date).toDate();
                                                                        this.setState({ futureSchoolYearState: _futureSchoolYearState });
                                                                    }}
                                                                    customTimeInput={<DatePickerInputControl />}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Fragment> : <Fragment>
                                                <p style={{ fontSize: '16px' }}><label>Select one option:</label></p>
                                                <ul style={{ paddingLeft: '20px' }}>
                                                    {
                                                        currentSchoolYear && <li>
                                                            <label><input type='radio' checked={schoolYearOption == 0} onClick={(e) => {
                                                                this.setState({ schoolYearOption: 0 })
                                                            }} /> Extend current school year end date</label>
                                                            <p style={{ paddingLeft: '20px' }}>
                                                                <span style={{ fontSize: '12px' }}>Current school year start date is <strong>{moment(currentSchoolYear.rec.sessionStartDateTime, 'YYYY-MM-DDThh:mm:ss').format(date_format())}</strong></span><br />
                                                                <span style={{ fontSize: '12px' }}>Current school year end date is <strong>{moment(currentSchoolYear.rec.sessionEndDateTime, 'YYYY-MM-DDThh:mm:ss').format(date_format())}</strong></span>
                                                            </p>
                                                        </li>
                                                    }
                                                    <li><label><input type='radio' checked={schoolYearOption == 1} onClick={(e) => {
                                                        this.setState({ schoolYearOption: 1 })
                                                    }} /> Request for new school year</label></li>
                                                    <li>
                                                        <label>
                                                            <input type='radio' checked={schoolYearOption == 2}
                                                            onClick={() => {
                                                                this.setState({ schoolYearOption: 2 });
                                                            }} /> Log in with previous school year
                                                        </label>
                                                    </li>
                                                </ul>
                                            </Fragment>
                                        }
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-sm-12 text-right'>
                                    <button className='btn btn-sm btn-danger' onClick={() => this.onClickExit()}>Exit</button>
                                    {currentSchoolYear && schoolYearOption == 0 ?
                                        <button className='btn btn-sm btn-success' onClick={() => {
                                            if (schoolYearOption == null) {
                                                _addNotificationError('Please select an option', this);
                                            } else {
                                                this.setState({ step: 1 });
                                            }
                                        }}>Continue</button>
                                        : <button className='btn btn-sm btn-success' onClick={(e) => {
                                            if (schoolYearOption == null) {
                                                _addNotificationError('Please select an option', this);
                                            } else {
                                                if (futureSchoolYear) {
                                                    this.saveSchoolYear(e, true);
                                                } else if (schoolYearOption == 2) {
                                                    this.onLoginWithPreviousSchoolYear();
                                                } else {
                                                    this.onRequestNewSchoolYear();
                                                } 
                                            }
                                        }}>Submit</button>
                                    }
                                </div>
                            </div>
                        </Fragment>
                            : step == 1 ? <Fragment>
                                <div className='row'>
                                    <div className='col-sm-12 text-center'>
                                        <div className='row form-group'>
                                            <div className='col-md-6'>
                                                <label>School Year Started On :</label>
                                            </div>
                                            <div className='col-md-6 text-left'>
                                                <strong>{moment(currentSchoolYearState.sessionStartDateTime, 'YYYY-MM-DD').format('MM/DD/YYYY')}</strong>
                                            </div>
                                        </div>
                                        <div className='row form-group'>
                                            <div className='col-md-6'>
                                                <label>School Year End Date :</label>
                                            </div>
                                            <div className='col-md-6 text-left'>
                                                <DatePicker
                                                    selected={moment(currentSchoolYearState.sessionEndDateTime, 'YYYY-MM-DDThh:mm:ss').toDate()}
                                                    dateFormat={date_format().replace('YYYY', 'yyyy').replace('DD', 'dd')}
                                                    minDate={new Date()}
                                                    onChange={(date) => {
                                                        const _currentSchoolYearState = this.state.currentSchoolYearState;
                                                        _currentSchoolYearState.sessionEndDateTime = moment(date).toDate();
                                                        this.setState({ currentSchoolYearState: _currentSchoolYearState });
                                                    }}
                                                    customTimeInput={<DatePickerInputControl />}
                                                />
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-sm-12 text-right'>
                                        <button className='btn btn-sm btn-danger' onClick={() => {
                                            this.setState({ step: 0 });
                                        }}>Back</button>
                                        <button className='btn btn-sm btn-success' disabled={loading} onClick={(e) => {
                                            this.saveSchoolYear(e);
                                        }}>Submit</button>
                                    </div>
                                </div>
                            </Fragment>
                                : null
                    }
                </div>
            </div>
        </Fragment >)
    }

    render() {
        const { futureSchoolYear } = this.props;
        const { isNewSchoolYearRequested } = this.state;
        return (
            <Fragment>
                <NotificationSystem ref="notificationSystem" />
                <div style={styles.container}>
                    {
                        futureSchoolYear ? <Fragment>
                            {this.renderSchoolYearSelectionOptions()}
                        </Fragment> : isNewSchoolYearRequested ? this.renderSchoolYearRequestedMessage() :
                            <Fragment>
                                {this.renderSchoolYearSelectionOptions()}
                            </Fragment>
                    }
                </div>
            </Fragment>
        );
    }
}
SchoolYearForm.contextTypes = {
    router: PropTypes.object.isRequired
}
export default SchoolYearForm;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Home/schoolYearForm.jsx